import { useAtomValue } from "jotai";
import { videoSDKAdapterAtom } from "../core/atoms";

export function useContainerComponent() {
  const adapter = useAtomValue(videoSDKAdapterAtom);
  return adapter.VideoComponents.Container;
}

export function useLocalVideoComponent() {
  const adapter = useAtomValue(videoSDKAdapterAtom);
  return adapter.VideoComponents.LocalVideo;
}

export function useRemoteVideoComponent() {
  const adapter = useAtomValue(videoSDKAdapterAtom);
  return adapter.VideoComponents.RemoteAudioVideo;
}

export function useLocalScreenShareComponent() {
  const adapter = useAtomValue(videoSDKAdapterAtom);
  return adapter.VideoComponents.LocalScreenShare;
}

export function useRemoteScreenShareComponent() {
  const adapter = useAtomValue(videoSDKAdapterAtom);
  return adapter.VideoComponents.RemoteScreenShare;
}

export function useRemoteDataComponent() {
  const adapter = useAtomValue(videoSDKAdapterAtom);
  return adapter.VideoComponents.RemoteData;
}
